module.exports = __webpack_public_path__ + "img/isbar_deteriorating_patient.e449c455.jpg";